'use client'
import { useEffect, useId, useRef, useState } from "react"
import styles from "./mobile-nav.module.css";
import { HiMenu } from "react-icons/hi";
import { FaTimes } from "react-icons/fa"
import Link from "next/link";
import HomeLink from "@/Components/Navigation/HomeLink";
import {TopBarBranding} from "@/Components/Branding/Branding";
import SocialNetworkLinks from "@/Components/Footer/SocialNetworkLinks/SocialNetworkLinks";
import {ThemeChanger} from "@/Components/Buttons/Buttons";
import NavCart from "@/Components/NavCart/NavCart";

export default function MobileNav() {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const dialogId = useId();
    const closeButtonRef = useRef(null);

    useEffect(() => {
        if (!mobileNavOpen) {
            document.body.style.removeProperty("overflow");
            return;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        closeButtonRef.current?.focus();

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setMobileNavOpen(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [mobileNavOpen]);

    return (
        <>
            <button
                type="button"
                className={styles.mobileNavBtn}
                onClick={() => setMobileNavOpen(true)}
                aria-expanded={mobileNavOpen}
                aria-controls={dialogId}
                aria-label="Open navigation menu"
            >
                <HiMenu size={30} className="m-0 p-0" />
            </button>
            <div
                id={dialogId}
                className={`${styles.mobileNavWrapper} ${mobileNavOpen ? styles.menuIsOpen : ""}`}
                role="dialog"
                aria-modal="true"
                aria-label="Mobile navigation"
                aria-hidden={!mobileNavOpen}
            >
                <div className={styles.mobileNav}>

                    <div>
                        <div className={styles.branding}>
                            <TopBarBranding />
                            <button
                                ref={closeButtonRef}
                                type="button"
                                className={styles.closeMobileNavBtn}
                                onClick={() => setMobileNavOpen(false)}
                                aria-label="Close navigation menu"
                            >
                                <FaTimes size={20} />
                            </button>
                        </div>
                        <div className={styles.mobileNavbarActionButtons}>
                            <ThemeChanger />
                            <NavCart />
                        </div>
                        <a href="tel:+14082617090" className="btn btn-success">
                            Call: +1 (408) 261-7090
                        </a>
                        <div className={styles.navLinks}>
                            <div><HomeLink onClick={() => setMobileNavOpen(false)}>Home</HomeLink></div>
                            <div><Link href="/solution/custom#solution-content" onClick={() => setMobileNavOpen(false)}>All Products</Link></div>
                            <div><Link href="/online-tests" onClick={() => setMobileNavOpen(false)}>Online Tests</Link></div>
                            <div><Link href="/about" onClick={() => setMobileNavOpen(false)}>About</Link></div>
                            <div><Link href="/support" onClick={() => setMobileNavOpen(false)}>Support</Link></div>
                            <div><Link href="/contact" onClick={() => setMobileNavOpen(false)}>Contact</Link></div>
                        </div>
                        <div className={styles.socialIcons}>
                            <SocialNetworkLinks />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
